import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  OrganizationUsers = 'OrganizationUsers',
}

export const useGetOrganizationUsersQuery = () => {
  const { getOrganizationUsers } = useServicesContext();
  return useQuery({
    queryKey: [CacheKey.OrganizationUsers],
    queryFn: () => getOrganizationUsers(),
  });
};
